<template>
    <el-button type="primary" :size="size" :disabled="disabled" @click="doXiaoshou">
        生成销售单据
    </el-button>
</template>
<script>
    /**
     * 生成销售单据
     * @author zjs
     * @time 2017-12-06
     */
    export default {
        name: 'LyButtonXiaoshou',
        props: {
            infoId: {
                type: [String, Number],
                default: ''
            }, 
            disabled: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: 'small'
            },
            // 作废完成后的回调函数
            callback: {
                type: Function,
                default: null
            } 
        },
        data () {
            return {
                uuid: ''
            }
        },  
        created () {
            this.uuid = this.$utils.createUUID()
        },
        methods: {
            doXiaoshou () {
                this.$api.create('api/createxiaoshou', {
                    uuid: this.uuid,
                    id: this.infoId
                }).then((rs) => {
                    this.$message({
                        type: 'success',
                        message: '生成成功.'
                    })
                    // 调用回调函数
                    if (this.callback) {
                        this.callback(rs.id)
                    }
                    this.uuid = this.$utils.createUUID()
                }).catch((msg) => {
                    this.$message({
                        type: 'info',
                        message: msg
                    })  
                    this.uuid = this.$utils.createUUID()
                })
            }
        }
    }
</script>